import React from 'react';
import { Box, Grid } from 'vendor/material';
import Tag from 'packages/cosell/src/components/Tag/Tag';
import { SharedHeader } from 'packages/cosell/src/components';
import {
  DisplayCloudType,
  TagColorEnum,
  AceInvitationCloudStatusEnum,
  AceOpportunityStageEnum,
  AceInvitationOriginEnum,
} from 'packages/cosell/src/types/enums';
import { AceInvitationResponse } from 'packages/cosell/src/types/AceInvitation.type';
import ToolTipCopy from 'packages/cosell/src/components/ToolTipCopy/ToolTipCopy';
import { SOURCE_TAG } from 'packages/cosell/src/utilities/constants/CoSellConstants';

interface InvitationDetailsHeaderProps {
  title?: string;
  subtitle?: string;
  status?: AceInvitationCloudStatusEnum;
  origin?: AceInvitationResponse['origin'];
  stage?: AceOpportunityStageEnum.PROSPECT;
  crmId?: AceInvitationResponse['metadata']['crmId'];
  opportunityId?: AceInvitationResponse['opportunityId'];
}

const InvitationDetailsHeader: React.FC<InvitationDetailsHeaderProps> = ({
  title,
  subtitle,
  status,
  origin,
  stage,
  crmId,
  opportunityId,
}) => {
  const toSentenceCase = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const renderOriginTag = (origin: AceInvitationOriginEnum) => {
    return origin === AceInvitationOriginEnum.PARTNER
      ? SOURCE_TAG.PARTNER_REFERRAL
      : origin === AceInvitationOriginEnum.AWS
      ? SOURCE_TAG.AWS_REFERRAL
      : '';
  };

  return (
    <>
      <Grid item xs={12}>
        <Box mb={1}>
          <SharedHeader
            title={title || ''}
            cloud={DisplayCloudType.AWS}
            subtitle={subtitle}
          />
        </Box>
        <Grid container spacing={1}>
          <Grid item>
            {origin && (
              <Tag
                color={TagColorEnum.STANDARD}
                data-testid="origin-tag-container"
              >
                <span data-testid="origin-tag">
                  Source: {renderOriginTag(origin)}
                </span>
              </Tag>
            )}
          </Grid>
          <Grid item>
            {status && (
              <>
                <Tag
                  data-testid="status-tag-container"
                  color={
                    status === AceInvitationCloudStatusEnum.ACCEPTED
                      ? TagColorEnum.GREEN
                      : status === AceInvitationCloudStatusEnum.REJECTED
                      ? TagColorEnum.RED
                      : TagColorEnum.STANDARD
                  }
                >
                  <span data-testid="status-tag">
                    Status: {toSentenceCase(status)}
                  </span>
                </Tag>
              </>
            )}
          </Grid>
          <Grid item>
            {stage && (
              <Tag
                color={TagColorEnum.STANDARD}
                data-testid="stage-tag-container"
              >
                <span data-testid="stage-tag">Stage: {stage}</span>
              </Tag>
            )}
          </Grid>
          <Grid item>
            {crmId && status === AceInvitationCloudStatusEnum.ACCEPTED && (
              <Tag
                color={TagColorEnum.STANDARD}
                data-testid="crm-id-tag-container"
              >
                <ToolTipCopy
                  content={crmId}
                  name="CRM ID:"
                  hideNameInTooltip={true}
                  data-testid="crm-id-tag"
                />
              </Tag>
            )}
          </Grid>
          <Grid item>
            {opportunityId && status === AceInvitationCloudStatusEnum.ACCEPTED && (
              <Tag
                color={TagColorEnum.STANDARD}
                data-testid="opportunity-id-tag-container"
              >
                <ToolTipCopy
                  content={opportunityId}
                  name="Cloud ID"
                  hideNameInTooltip={true}
                  showColon={true}
                  data-testid="opportunity-id-tag"
                />
              </Tag>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InvitationDetailsHeader;
